export enum WizardStep {
  General = 0,
  ScreenConfiguration = 1,
  Advanced = 2,
}
